import { de_ListSimulationsCommand, se_ListSimulationsCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
export class ListSimulationsCommand extends $Command.classBuilder()
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
    ];
})
    .s("SimulationService", "ListSimulations", {})
    .n("SimulationServiceClient", "ListSimulationsCommand")
    .f(void 0, void 0)
    .ser(se_ListSimulationsCommand)
    .de(de_ListSimulationsCommand)
    .build() {
}
